import "./form.css"
import Form from "./Form"
import FormRequiredSlot from "./FormRequiredSlot"

export type { FormProps } from "./Form"
export type { FormRequiredSlotProps } from "./FormRequiredSlot"
export default Object.assign(Form, {
  RequiredSlot: FormRequiredSlot,
})
